import { promises } from '../fs.js';
export { promises as default } from '../fs.js';
import '../chunk-44e51b61.js';
import '../chunk-4bd36a8f.js';
import '../chunk-ce0fbc82.js';
import '../chunk-b4205b57.js';
import '../chunk-5decc758.js';
import '../chunk-2eac56ff.js';
import '../chunk-4ccc3a29.js';
import '../assert.js';
import '../util.js';
import '../path.js';
import '../chunk-23dbec7b.js';
import '../events.js';
import '../stream.js';
import '../chunk-6c718bbe.js';
import '../url.js';
import '../chunk-924bb2e1.js';
import '../chunk-b04e620d.js';
import '../buffer.js';

const {
  access,
  copyFile,
  cp,
  open,
  opendir,
  rename,
  truncate,
  rm,
  rmdir,
  mkdir,
  readdir,
  readlink,
  symlink,
  lstat,
  stat,
  link,
  unlink,
  chmod,
  lchmod,
  lchown,
  chown,
  utimes,
  realpath,
  mkdtemp,
  writeFile,
  appendFile,
  readFile,
  watch,
} = promises;

export { access, appendFile, chmod, chown, copyFile, cp, lchmod, lchown, link, lstat, mkdir, mkdtemp, open, opendir, readFile, readdir, readlink, realpath, rename, rm, rmdir, stat, symlink, truncate, unlink, utimes, watch, writeFile };
